import script from "./laundry-report-page.vue?vue&type=script&lang=ts&setup=true"
export * from "./laundry-report-page.vue?vue&type=script&lang=ts&setup=true"

import "./laundry-report-page.vue?vue&type=style&index=0&id=5ffe76a0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ffe76a0"]])

export default __exports__